import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  ErrorInterceptorName,
  ErrorInterceptorNameValue
} from '@shared/interceptors/common/enum/error-interceptor-name';
import { Observable } from 'rxjs';
import { BaseErrorInterceptor } from './base-error-interceptor';
import { ToastService } from '@shared/ui/kit/toast/toast.service';

@Injectable()
export class ErrorPayloadTooLargeInterceptor extends BaseErrorInterceptor {
  private readonly toastService: ToastService = inject(ToastService);

  override errorCode: string | null = null;
  override readonly interceptorName: ErrorInterceptorNameValue = ErrorInterceptorName.payloadTooLarge;
  override readonly httpStatusCode: HttpStatusCode = HttpStatusCode.PayloadTooLarge as const;

  protected handleError(err: HttpErrorResponse): Observable<any> {
    this.toastService.error({
      title: "This didn't go right",
      message: this.getErrorMessageFromHttpErrorResponse(err) ?? 'Payload too large'
    });
    return this.emptyResponse();
  }
}
